const STORAGE_PREFIX = 'adulting_offline_v1';

function storageKey(scope: string, userId: string) {
  return `${STORAGE_PREFIX}:${scope}:${userId}`;
}

export function readScopedLocalJson<T>(scope: string, userId: string): T | null {
  if (typeof window === 'undefined' || !userId) {
    return null;
  }

  try {
    const raw = window.localStorage.getItem(storageKey(scope, userId));
    if (!raw) return null;
    return JSON.parse(raw) as T;
  } catch {
    return null;
  }
}

export function writeScopedLocalJson(scope: string, userId: string, value: unknown) {
  if (typeof window === 'undefined' || !userId) {
    return;
  }

  try {
    window.localStorage.setItem(storageKey(scope, userId), JSON.stringify(value));
  } catch {
    // Ignore storage failures and keep the app usable.
  }
}

export function removeScopedLocalJson(scope: string, userId: string) {
  if (typeof window === 'undefined' || !userId) {
    return;
  }

  try {
    window.localStorage.removeItem(storageKey(scope, userId));
  } catch {
    // Ignore storage failures and keep the app usable.
  }
}
